export type FeatureFlagId = string

export interface FeatureFlagDefinition {
  id: FeatureFlagId
  name: string
  description: string
  defaultEnabled: boolean
}

/**
 * Registry of user-toggleable feature flags. Empty by default — the flag
 * machinery (store, events, settings section) remains intact so that future
 * experimental features can be gated behind a one-line entry here without
 * re-introducing the plumbing.
 *
 * When adding a flag:
 *   1. Add an `id` constant to `FEATURE_FLAG_IDS` for type-safe lookups.
 *   2. Push a `FeatureFlagDefinition` into `FEATURE_FLAG_REGISTRY`.
 *   3. Consumers read state via `FeatureFlagsStore.isEnabled(id)` and react
 *      to lifecycle via `FeatureFlagEnabledEvent` / `FeatureFlagDisabledEvent`.
 */
export const FEATURE_FLAG_IDS = {
} as const

export const FEATURE_FLAG_REGISTRY: FeatureFlagDefinition[] = []
